import { MailjetIndexComponent } from './mailjet/mailjet-index/mailjet-index.component';
import { AngebotsversionslistenEditComponent } from './listenverwaltung/angebotsversionslisten/angebotsversionslisten-edit/angebotsversionslisten-edit.component';
import { DisplayEditComponent } from './displays/display-edit/display-edit.component';
import { DisplayCreateComponent } from './displays/display-create/display-create.component';
import { DisplayIndexComponent } from './displays/display-index/display-index.component';
import { IndustriepartnerNeuComponent } from './industriepartner-neu/industriepartner-neu.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoggedInGuard} from './core/guards/logged-in.guard';
import {UserRoles} from './shared/model';
import {IndustriepartnerComponent} from './industriepartner/industriepartner.component';
import {IndustriepartnerDetailsComponent} from './industriepartner-details/industriepartner-details.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ProfilComponent} from './profil/profil.component';
import {AdminComponent} from './admin/admin.component';
import {BerechnungComponent} from './berechnung/berechnung.component';
import { AngebotsversionslistenIndexComponent } from './listenverwaltung/angebotsversionslisten/angebotsversionslisten-index/angebotsversionslisten-index.component';
import { ActivitychartComponent } from './activitychart/activitychart.component';
import { OrderchartComponent } from './orderchart/orderchart.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
       path: 'dashboard',
       component: DashboardComponent,
       canActivate: [LoggedInGuard]
    },
    {
      path: 'displays',
      component: DisplayIndexComponent,
      canActivate: [LoggedInGuard],
      data: {
          roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
      },
    },
    {
      path: 'display-neu',
      component: DisplayCreateComponent,
      canActivate: [LoggedInGuard],
      data: {
          roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
      },
    },
    {
      path: 'display/:id',
      component: DisplayEditComponent,
      canActivate: [LoggedInGuard],
      data: {
          roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
      },
    },
    {
      path: 'artikelstamm-einlesen',
      loadChildren:
          () => import('./artikelstamm-einlesen/artikelstamm-einlesen.module').then(m => m.ArtikelstammEinlesenModule),
      canActivate: [LoggedInGuard],
      data: {
          roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
      },
    },
    {
        path: 'listen-einlesen',
        loadChildren:
            () => import('./listen-einlesen/listen-einlesen.module').then(m => m.ListenEinlesenModule),
        canActivate: [LoggedInGuard],
        data: {
            roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
        },
    },
    {
        path: 'listen-zuweisen',
        loadChildren:
            () => import('./listen-zuweisen/listen-zuweisen.module').then(m => m.ListenZuweisenModule),
        canActivate: [LoggedInGuard],
        data: {
            roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
        },
    },

    {
        path: 'listenverwaltung',
        loadChildren:
            () => import('./listenverwaltung/listenverwaltung.module').then(m => m.ListenverwaltungModule),
        canActivate: [LoggedInGuard],
        data: {
            roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
        },
    },
    {
      path: 'angebotsversionslisten',
      canActivate: [LoggedInGuard],
      component: AngebotsversionslistenIndexComponent,
      data: {
          roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
      },
    },
    {
      path: 'angebotsversionslisten/:id',
      canActivate: [LoggedInGuard],
      component: AngebotsversionslistenEditComponent,
      data: {
          roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
      },
    },
    {
        path: 'kundenverwaltung',
        loadChildren:
            () => import('./kundenverwaltung/kundenverwaltung.module').then(m => m.KundenverwaltungModule),
        canActivate: [LoggedInGuard],
        data: {
            roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
        },
    },
    {
        path: 'reporting',
        loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportingModule),
        canActivate: [LoggedInGuard],
        data: {
            roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
        },
    },
  {
    path: 'industriepartner',
    component: IndustriepartnerComponent,
    canActivate: [LoggedInGuard],
    data: {
      roles: [UserRoles.ROLE_ADMIN]
    }
  },
  {
    path: 'industriepartner-neu',
    component: IndustriepartnerNeuComponent,
    canActivate: [LoggedInGuard],
    data: {
      roles: [UserRoles.ROLE_ADMIN]
    }
  },
  {
    path: 'vergleichsrechnung',
    component: BerechnungComponent,
    canActivate: [LoggedInGuard],
    data: {
      roles: [UserRoles.ROLE_ADMIN]
    }
  },
  {
    path: 'activitychart',
    component: ActivitychartComponent,
    canActivate: [LoggedInGuard],
    data: {
      roles: [UserRoles.ROLE_ADMIN]
    }
  },
  {
    path: 'orderchart',
    component: OrderchartComponent,
    canActivate: [LoggedInGuard],
    data: {
      roles: [UserRoles.ROLE_ADMIN]
    }
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [LoggedInGuard],
    data: {
      roles: [UserRoles.ROLE_ADMIN]
    }
  },
  {
    path: 'mailjet',
    component: MailjetIndexComponent,
    canActivate: [LoggedInGuard],
    data: {
      roles: [UserRoles.ROLE_ADMIN]
    }
  },
  {
    path: 'profil',
    component: ProfilComponent,
    canActivate: [LoggedInGuard]
  },
  {
    path: 'industriepartner/:anbieterNr',
    component: IndustriepartnerDetailsComponent,
    canActivate: [LoggedInGuard],
    data: {
      roles: [UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER]
    }
  },
    {
        path: 'vorgabewerte',
        loadChildren: () => import('./vorgabewerte/vorgabewerte.module').then(m => m.VorgabewerteModule),
        canActivate: [LoggedInGuard],
        data: {
            roles: [UserRoles.ROLE_INDUSTRIEPARTNER, UserRoles.ROLE_ADMIN, UserRoles.ROLE_INDUSTRIEPARTNER_SUB],
        },
    },
    {
        path: 'showcase',
        loadChildren: () => import('./showcase/showcase.module').then(m => m.ShowcaseModule),
        canActivate: [LoggedInGuard],
        data: { roles: [UserRoles.ROLE_ADMIN], testEnabled: true },
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
